module.exports = __webpack_public_path__ + "static/media/ni.23d34c1e.svg";